import { Button } from "@mui/material";
import { useContext, useEffect } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomTooltip from "../../../../components/CustomTooltip";
import SpinningIcon from "../../../../components/SpinningIcon";
import { Toast } from "../../../../components/Toast";
import { NotificationContext } from "../../../../contexts/NotificationContext";

const CreateHeatmapButton = ({
  loadingMessage,
  setLoading,
  children,
  ...props
}) => {
  const { isLoading, setIsLoading } = useContext(NotificationContext);
  const colors = useColors();
  const { createHeatmap } = useAPI();

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  const handleCreateHeatmap = async () => {
    setIsLoading(true);

    try {
      await createHeatmap();
      Toast.success("Heatmaps created successfully");
    } catch (error) {
      Toast.error("Failed to create heatmaps");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CustomTooltip title={isLoading ? loadingMessage : ""}>
      <span>
        <Button
          sx={{
            background: colors.grey_50,
            color: colors.contrast_text_dark,
            height: "32px",
            marginLeft: "5px",
            border: "1px solid",
            borderRadius: "8px",
          }}
          startIcon={<SpinningIcon isLoading={isLoading} />}
          onClick={handleCreateHeatmap}
          disabled={isLoading}
          {...props}
          style={{ textTransform: "none" }}
        >
          {children}
        </Button>
      </span>
    </CustomTooltip>
  );
};

export default CreateHeatmapButton;
